import { gql } from '@apollo/client';

export const UserLoginGql = gql`
  query UserLogin($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      email
      id
      token
    }
  }
`;

export const UserFindByIdGql = gql`
  query UserFindById($id: Int!) {
    users(where: { id: { _eq: $id } }) {
      id
      name
      email
      portal_roles {
        store {
          id
          name
          data_bulk_upload
          enable_consumer_guaranteed_price
          enable_dealer_guaranteed_price
          enable_manual_lead
          calibrationID
          zip
          enable_dealer_zipcode
          vehicles_aggregate(
            where: { appraisals: { appraiser_id: { _is_null: false } } }
          ) {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
`;
